import Vue from 'vue';
import App from './App.vue';
import Router from 'vue-router';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import NProgress from 'nprogress';
import VueAgile from 'vue-agile';
import * as VueGoogleMaps from 'vue2-google-maps';
import axios from 'axios';
import VueAxios from 'vue-axios';
import 'swiper/dist/css/swiper.css';
import '../node_modules/nprogress/nprogress.css';
import VueCurrencyFilter from 'vue-currency-filter';
import BackToTop from 'vue-backtotop';
import zoom from 'vue-image-zoom';
import imageZoom from 'vue-image-zoomer';
import 'vue-image-zoom/dist/vue-image-zoom.css';
import store from '@/store';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import VueMeta from 'vue-meta';
import FBSignInButton from 'vue-facebook-signin-button';
import { VueStars } from 'vue-stars';
import { config_settings } from '@/config.js';
import { getSections } from '@/service/sections.service';
import { getConfigData } from '@/service/config.service';
import { useAxiosCustomInterceptor } from '@/helpers/interceptor.helpers';
import { addEcommerceDependencies } from '@/helpers/dependencies.helpers';
import { saveConfigData } from '@/helpers/localStorage.helpers';
import { getBasicRoutes, getAccountRoutes, getEcommerceRoutes, getDynamicRoutes } from '@/router';
import { useFilters } from '@/helpers/filters.helpers';

Vue.use(VueAxios, axios);
Vue.use(Router);
Vue.use(zoom);
Vue.use(VueGoogleMaps, { load: { key: '', libraries: 'places' } });
Vue.use(BackToTop);
Vue.use(VueNumberInput);
Vue.component('vue-stars', VueStars);
Vue.component('image-zoom', imageZoom);
Vue.use(VueAwesomeSwiper);
Vue.use(VueAgile);
Vue.config.productionTip = false;
Vue.use(FBSignInButton);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.use(VueCurrencyFilter, {
  symbol: 'S/',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true,
});
useFilters();
useAxiosCustomInterceptor();

const mountApp = (router, configDataFromServer, sections) => {
  router.beforeResolve((to, from, next) => {
    if (to.name) {
      NProgress.start();
    }
    next();
  });

  router.afterEach(() => {
    NProgress.done();
  });

  let vm = new Vue({
    router,
    store,
    render: (h) =>
      h(App, {
        props: {
          configData: configDataFromServer,
          section_list: sections,
        },
      }),
  }).$mount('#app');
};

getConfigData()
  .then((response) => {
    saveConfigData(response.data);
    const configDataFromServer = response.data[0];
    const isEcommercePage = configDataFromServer.general.isEcommercePage;
    const isLoggingAvailable = configDataFromServer.general.isLoggingAvailable;
    const isCheckoutProdVersion = config_settings.PROD_ENV;
    const ecommerceProps = configDataFromServer.ecommerceProps;
    isEcommercePage ? addEcommerceDependencies(isCheckoutProdVersion, ecommerceProps) : null;
    getSections()
      .then((response) => {
        const sections = response.data;
        const dynamicRoutes = getDynamicRoutes(sections, configDataFromServer);
        const router = new Router(getBasicRoutes(configDataFromServer));
        if (isLoggingAvailable) {
          router.addRoutes(getAccountRoutes(configDataFromServer));
        }
        if (isEcommercePage) {
          router.addRoutes(getEcommerceRoutes(configDataFromServer));
        }
        router.addRoutes(dynamicRoutes);
        mountApp(router, configDataFromServer, sections);
      })
      .catch((error) => {
        console.log('Unknown error at get sections data from server');
      });
  })
  .catch((error) => {
    console.log('Unknown error at get config data from server : ', error);
  });
